var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldLevel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 8.14844,
    height: 11.6484,
    viewBox: "0 0 8.14844 11.6484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.07422 0C1.80469 0 0 1.80469 0 4.07422C0 7.13672 4.07422 11.6484 4.07422 11.6484C4.07422 11.6484 8.14844 7.13672 8.14844 4.07422C8.14844 1.80469 6.34375 0 4.07422 0V0M1.14844 4.07422C1.14844 2.46094 2.46094 1.14844 4.07422 1.14844C5.6875 1.14844 7 2.46094 7 4.07422C7 5.74219 5.30469 8.25781 4.07422 9.84375C2.87109 8.28516 1.14844 5.74219 1.14844 4.07422V4.07422M2.625 4.07422C2.625 3.28125 3.28125 2.625 4.07422 2.625C4.86719 2.625 5.52344 3.28125 5.52344 4.07422C5.52344 4.86719 4.86719 5.52344 4.07422 5.52344C3.28125 5.52344 2.625 4.86719 2.625 4.07422V4.07422",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldLevel);
export default __webpack_public_path__ + "static/media/field-level.79c0d4154d8d0519bc6858de734dcdfb.svg";
export { ForwardRef as ReactComponent };